/* eslint-disable */
import React,{useState,useEffect} from "react";
var T={accent:"#C48A0E",green:"#1E8A55",red:"#C0392B",blue:"#1A5FB4",purple:"#6527BE",teal:"#0E7490",orange:"#C05800",muted:"#7A90B0",text:"#1A2235",border:"#E2E8F3",card:"#fff",faint:"#F7F9FD",font:"DM Sans,system-ui",mono:"IBM Plex Mono,monospace"};
var sc=function(s){return({healthy:T.green,Active:T.green,active:T.green,completed:T.green,approved:T.green,Online:T.green,unhealthy:T.red,failed:T.red,rejected:T.red,critical:T.red,Critical:T.red,pending:T.accent,Pending:T.accent,medium:T.orange,high:T.accent,High:T.accent,low:T.blue,processing:T.blue,Running:T.blue})[s]||T.muted;};
function SC(p){return <div style={{background:T.card,borderRadius:12,padding:"16px 18px",border:"1px solid "+T.border}}><div style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase"}}>{p.l}</div><div style={{fontSize:28,fontWeight:800,color:p.c||T.accent,fontFamily:T.mono,marginTop:4}}>{p.v}</div><div style={{fontSize:11,color:T.muted,marginTop:2}}>{p.s}</div></div>;}
function Bd({t,c}){return <span style={{padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,background:(c||T.muted)+"15",color:c||T.muted}}>{t}</span>;}
function Btn({onClick,bg,children,sm}){return <button onClick={onClick} style={{padding:sm?"5px 10px":"8px 16px",borderRadius:8,border:"none",background:bg||T.accent,color:"#fff",fontSize:sm?10:12,fontWeight:700,cursor:"pointer",fontFamily:T.font}}>{children}</button>;}
function Crd({title,children,accent}){return <div style={{background:T.card,borderRadius:12,border:"1px solid "+(accent?T.accent+"33":T.border),padding:18,marginBottom:16}}>{title&&<div style={{fontSize:14,fontWeight:700,marginBottom:14}}>{title}</div>}{children}</div>;}
function TH({children}){return <th style={{textAlign:"left",padding:"10px 12px",borderBottom:"2px solid "+T.border,color:T.muted,fontSize:11,fontWeight:600,textTransform:"uppercase"}}>{children}</th>;}
function TD({children,mono,bold}){return <td style={{padding:"10px 12px",color:T.text,fontFamily:mono?T.mono:T.font,fontSize:mono?11:12,fontWeight:bold?700:400}}>{children}</td>;}
function Empty({t,s}){return <div style={{textAlign:"center",padding:"40px 20px",color:T.muted}}><div style={{fontWeight:700,color:T.text,marginBottom:4}}>{t}</div><div style={{fontSize:12}}>{s}</div></div>;}
function useF(props,endpoints){
  var _s={};var _set={};endpoints.forEach(function(e){var s=useState(e.def||[]);_s[e.key]=s[0];_set[e.key]=s[1];});
  var _l=useState(true);_s.loading=_l[0];_set.loading=_l[1];
  useEffect(function(){var t=props.token||localStorage.getItem("auravex_token");if(!t)return;var h={"Content-Type":"application/json",Authorization:"Bearer "+t};
    function fd(){Promise.all(endpoints.map(function(e){return fetch(""+e.path,{headers:h}).then(function(r){return r.ok?r.json():(e.def||[]);}).catch(function(){return e.def||[];});}))
    .then(function(d){endpoints.forEach(function(e,i){_set[e.key](d[i]);});_set.loading(false);}).catch(function(){_set.loading(false);});}
    fd();var iv=setInterval(fd,10000);return function(){clearInterval(iv);};},[props.token]);
  return _s;
}

// ============================================================
// PAGE 1: System Health Dashboard
// ============================================================
export function SystemHealthPage(props){
  var d=useF(props,[
    {key:"health",path:"/api/agent/health",def:{}},
    {key:"stats",path:"/api/agent/agent-stats",def:{}},
    {key:"checks",path:"/api/agent/agent-health-checks"},
    {key:"playbooks",path:"/api/agent/agent-playbooks"},
    {key:"policies",path:"/api/agent/agent-policies"},
  ]);
  var [refreshing,setRefreshing]=useState(false);

  function refresh(){
    setRefreshing(true);
    fetch("/api/agent/health").then(function(r){return r.json();}).then(function(){setRefreshing(false);}).catch(function(){setRefreshing(false);});
  }

  if(d.loading)return <div style={{padding:60,textAlign:"center",color:T.muted,fontFamily:T.font}}>Loading...</div>;
  var h=d.health||{};var ch=h.checks||{};var db=ch.database||{};var dt=ch.data||{};
  var st=d.stats||{};

  return <div style={{fontFamily:T.font,color:T.text}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
      <div><div style={{fontSize:22,fontWeight:800}}>System Health Dashboard</div><div style={{fontSize:13,color:T.muted,marginTop:4}}>Real-time platform monitoring & diagnostics</div></div>
      <Btn onClick={refresh} bg={refreshing?T.muted:T.green}>{refreshing?"Checking...":"Run Health Check"}</Btn>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:14,marginBottom:24}}>
      <SC l="Platform Status" v={h.status==="healthy"?"HEALTHY":"DEGRADED"} s={"Latency: "+(h.latency_ms||0)+"ms"} c={h.status==="healthy"?T.green:T.red}/>
      <SC l="Database" v={db.status==="healthy"?"ONLINE":"DOWN"} s={(db.latency_ms||0)+"ms response"} c={db.status==="healthy"?T.green:T.red}/>
      <SC l="Events" v={dt.events||0} s="Total tracked" c={T.blue}/>
      <SC l="AI Models" v={dt.models||0} s="Registered" c={T.accent}/>
      <SC l="Cameras" v={dt.cameras||0} s="Configured" c={T.teal}/>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
      <Crd title="Platform Components" accent>
        {[
          {name:"Backend API",status:h.status==="healthy"?"Online":"Offline",detail:"Node.js + Express on port 5000"},
          {name:"Database",status:db.status||"unknown",detail:"PostgreSQL \u2022 "+(db.latency_ms||0)+"ms latency"},
          {name:"Frontend",status:"Online",detail:"React SPA on Nginx port 3000"},
          {name:"AI Models",status:(dt.models||0)>0?"Active":"Inactive",detail:(dt.models||0)+" models registered"},
          {name:"ECA Rules",status:(dt.rules||0)>0?"Active":"Inactive",detail:(dt.rules||0)+" rules configured"},
          {name:"AI Tables",status:(dt.ai_tables||0)>0?"Active":"Inactive",detail:(dt.ai_tables||0)+" AI tables"},
          {name:"Agent Policies",status:((st.policies||{}).active||0)>0?"Active":"Inactive",detail:((st.policies||{}).total||0)+" policies loaded"},
          {name:"Playbooks",status:((st.playbooks||{}).active||0)>0?"Active":"Inactive",detail:((st.playbooks||{}).total||0)+" playbooks configured"},
        ].map(function(c,i){return <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:i<7?"1px solid "+T.border+"44":"none"}}>
          <div><div style={{fontSize:12,fontWeight:600}}>{c.name}</div><div style={{fontSize:10,color:T.muted}}>{c.detail}</div></div>
          <Bd t={c.status} c={sc(c.status)}/>
        </div>;})}
      </Crd>

      <Crd title="Agent Operations Stats">
        {[
          {l:"Total Actions Executed",v:(st.actions||{}).total||0,c:T.blue},
          {l:"Actions Completed",v:(st.actions||{}).completed||0,c:T.green},
          {l:"Actions Failed",v:(st.actions||{}).failed||0,c:T.red},
          {l:"Pending Approvals",v:(st.approvals||{}).pending||0,c:T.accent},
          {l:"Active Policies",v:(st.policies||{}).active||0,c:T.purple},
          {l:"Active Playbooks",v:(st.playbooks||{}).active||0,c:T.teal},
          {l:"Pending Recommendations",v:(st.recommendations||{}).pending||0,c:T.orange},
          {l:"Health Checks (1hr)",v:(st.health_checks||{}).total||0,c:T.green},
        ].map(function(r,i){return <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:i<7?"1px solid "+T.border+"44":"none"}}>
          <span style={{fontSize:12,color:T.muted}}>{r.l}</span>
          <span style={{fontSize:13,fontWeight:800,color:r.c,fontFamily:T.mono}}>{r.v}</span>
        </div>;})}
      </Crd>
    </div>

    <Crd title={"Health Check History ("+d.checks.length+")"}>
      {d.checks.length===0?<Empty t="No Health Checks Yet" s="Health checks are logged automatically on each /api/agent/health call"/>:
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}><thead><tr><TH>Component</TH><TH>Status</TH><TH>Latency</TH><TH>Details</TH><TH>Checked At</TH></tr></thead><tbody>
      {d.checks.slice(0,15).map(function(c,i){return <tr key={i} style={{borderBottom:"1px solid "+T.border+"44"}}>
        <TD bold>{c.component}</TD>
        <TD><Bd t={c.status} c={sc(c.status)}/></TD>
        <TD mono>{c.latency_ms||0}ms</TD>
        <TD>{c.error_message||JSON.stringify(c.details||{}).substring(0,60)}</TD>
        <TD>{new Date(c.checked_at).toLocaleString()}</TD>
      </tr>;})}</tbody></table>}
    </Crd>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
      <Crd title={"Active Policies ("+d.policies.length+")"}>
        {d.policies.slice(0,8).map(function(p,i){return <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:i<7?"1px solid "+T.border+"44":"none"}}>
          <div><div style={{fontSize:11,fontWeight:600}}>{p.action_type}</div><div style={{fontSize:9,color:T.muted}}>{p.description}</div></div>
          <div style={{display:"flex",gap:4}}><Bd t={p.risk_level} c={sc(p.risk_level)}/><Bd t={p.approval_mode} c={p.approval_mode==="auto"?T.green:T.accent}/></div>
        </div>;})}
      </Crd>

      <Crd title={"Incident Playbooks ("+d.playbooks.length+")"}>
        {d.playbooks.map(function(p,i){return <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:i<d.playbooks.length-1?"1px solid "+T.border+"44":"none"}}>
          <div><div style={{fontSize:11,fontWeight:600}}>{p.name}</div><div style={{fontSize:9,color:T.muted}}>Trigger: {p.trigger_event} \u2022 Cooldown: {p.cooldown_seconds}s</div></div>
          <div style={{display:"flex",gap:4}}><Bd t={p.is_active?"Active":"Off"} c={p.is_active?T.green:T.muted}/><Bd t={(p.actions||[]).length+" steps"} c={T.blue}/></div>
        </div>;})}
      </Crd>
    </div>

    <div style={{marginTop:16,padding:12,background:T.faint,borderRadius:8,fontSize:11,color:T.muted,fontFamily:T.mono,textAlign:"center"}}>
      Platform v{h.version||"5.0"} \u2022 Uptime: {h.uptime?Math.floor(h.uptime/60)+"m "+Math.floor(h.uptime%60)+"s":"--"} \u2022 Last Check: {h.timestamp?new Date(h.timestamp).toLocaleString():"--"}
    </div>
  </div>;
}

// ============================================================
// PAGE 2: Agent Action History (Audit Trail)
// ============================================================
export function AgentHistoryPage(props){
  var d=useF(props,[{key:"actions",path:"/api/agent/agent-actions"}]);
  if(d.loading)return <div style={{padding:60,textAlign:"center",color:T.muted,fontFamily:T.font}}>Loading...</div>;
  return <div style={{fontFamily:T.font,color:T.text}}>
    <div style={{fontSize:22,fontWeight:800,marginBottom:4}}>Agent Action History</div>
    <div style={{fontSize:13,color:T.muted,marginBottom:24}}>Full audit trail of all AI agent operations</div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
      <SC l="Total Actions" v={d.actions.length} s="All time" c={T.blue}/>
      <SC l="Completed" v={d.actions.filter(function(a){return a.status==="completed";}).length} s="Successful" c={T.green}/>
      <SC l="Failed" v={d.actions.filter(function(a){return a.status==="failed";}).length} s="Errors" c={T.red}/>
      <SC l="Pending" v={d.actions.filter(function(a){return a.status==="pending"||a.status==="processing";}).length} s="In progress" c={T.accent}/>
    </div>

    <Crd title={"Actions ("+d.actions.length+")"}>
      {d.actions.length===0?<Empty t="No Agent Actions Yet" s="Use the AI Command Center to execute commands. All actions are logged here."/>:
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}><thead><tr><TH>ID</TH><TH>Command</TH><TH>Intent</TH><TH>Risk</TH><TH>Mode</TH><TH>Status</TH><TH>Actor</TH><TH>Time</TH></tr></thead><tbody>
      {d.actions.map(function(a,i){return <tr key={i} style={{borderBottom:"1px solid "+T.border+"44"}}>
        <TD mono>#{a.id}</TD>
        <TD>{(a.input_command||"--").substring(0,40)}{(a.input_command||"").length>40?"...":""}</TD>
        <TD mono>{a.parsed_intent||"--"}</TD>
        <TD><Bd t={a.risk_level||"low"} c={sc(a.risk_level||"low")}/></TD>
        <TD><Bd t={a.approval_mode||"auto"} c={a.approval_mode==="auto"?T.green:T.accent}/></TD>
        <TD><Bd t={a.status||"pending"} c={sc(a.status||"pending")}/></TD>
        <TD>{a.actor||"--"}</TD>
        <TD>{new Date(a.created_at).toLocaleString()}</TD>
      </tr>;})}</tbody></table>}
    </Crd>
  </div>;
}

// ============================================================
// PAGE 3: Approval Queue
// ============================================================
export function ApprovalQueuePage(props){
  var d=useF(props,[
    {key:"approvals",path:"/api/agent/agent-approvals"},
    {key:"recs",path:"/api/agent/agent-recommendations"},
  ]);

  function handleApproval(id,status){
    var t=props.token||localStorage.getItem("auravex_token");
    fetch("/api/agent/agent-approvals/"+id,{
      method:"PATCH",headers:{"Content-Type":"application/json",Authorization:"Bearer "+t},
      body:JSON.stringify({status:status,approved_by:"admin",approved_at:new Date().toISOString()})
    }).then(function(){window.location.reload();});
  }

  function handleRec(id,status){
    var t=props.token||localStorage.getItem("auravex_token");
    fetch("/api/agent/agent-recommendations/"+id,{
      method:"PATCH",headers:{"Content-Type":"application/json",Authorization:"Bearer "+t},
      body:JSON.stringify({status:status,accepted_by:"admin",accepted_at:new Date().toISOString()})
    }).then(function(){window.location.reload();});
  }

  if(d.loading)return <div style={{padding:60,textAlign:"center",color:T.muted,fontFamily:T.font}}>Loading...</div>;
  var pending=d.approvals.filter(function(a){return a.status==="pending";});

  return <div style={{fontFamily:T.font,color:T.text}}>
    <div style={{fontSize:22,fontWeight:800,marginBottom:4}}>Approval Queue & Recommendations</div>
    <div style={{fontSize:13,color:T.muted,marginBottom:24}}>Review and approve agent actions \u2022 Accept or dismiss AI recommendations</div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
      <SC l="Pending Approvals" v={pending.length} s="Awaiting review" c={pending.length>0?T.accent:T.green}/>
      <SC l="Total Approvals" v={d.approvals.length} s="All time" c={T.blue}/>
      <SC l="Recommendations" v={d.recs.length} s={d.recs.filter(function(r){return r.status==="pending";}).length+" pending"} c={T.purple}/>
      <SC l="Accepted" v={d.recs.filter(function(r){return r.status==="accepted";}).length} s="Implemented" c={T.green}/>
    </div>

    <Crd title={"Pending Approvals ("+pending.length+")"}>
      {pending.length===0?<Empty t="No Pending Approvals" s="All agent actions are either auto-approved or have been reviewed"/>:
      <div style={{display:"flex",flexDirection:"column",gap:12}}>{pending.map(function(a,i){return <div key={i} style={{background:T.faint,border:"1px solid "+T.accent+"33",borderRadius:10,padding:14}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
          <div><div style={{fontWeight:700,fontSize:13}}>{a.action_summary||"Action #"+a.action_id}</div><div style={{fontSize:10,color:T.muted,marginTop:2}}>Requested by: {a.requested_by||"agent"} \u2022 {new Date(a.created_at).toLocaleString()}</div></div>
          <Bd t={a.risk_level||"medium"} c={sc(a.risk_level||"medium")}/>
        </div>
        <div style={{display:"flex",gap:8}}>
          <Btn onClick={function(){handleApproval(a.id,"approved");}} bg={T.green} sm>Approve</Btn>
          <Btn onClick={function(){handleApproval(a.id,"rejected");}} bg={T.red} sm>Reject</Btn>
        </div>
      </div>;})}</div>}
    </Crd>

    <Crd title={"All Approvals ("+d.approvals.length+")"}>
      {d.approvals.length===0?<Empty t="No Approval Records" s="Approval records appear when medium/high risk actions are requested"/>:
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}><thead><tr><TH>Action</TH><TH>Risk</TH><TH>Status</TH><TH>Requested By</TH><TH>Approved By</TH><TH>Time</TH></tr></thead><tbody>
      {d.approvals.map(function(a,i){return <tr key={i} style={{borderBottom:"1px solid "+T.border+"44"}}>
        <TD>{a.action_summary||"Action #"+(a.action_id||a.id)}</TD>
        <TD><Bd t={a.risk_level||"--"} c={sc(a.risk_level||"low")}/></TD>
        <TD><Bd t={a.status} c={sc(a.status)}/></TD>
        <TD>{a.requested_by||"--"}</TD>
        <TD>{a.approved_by||"--"}</TD>
        <TD>{new Date(a.created_at).toLocaleString()}</TD>
      </tr>;})}</tbody></table>}
    </Crd>

    <Crd title={"AI Recommendations ("+d.recs.length+")"}>
      {d.recs.length===0?<Empty t="No Recommendations Yet" s="AI will generate optimization suggestions as the platform collects more data"/>:
      <div style={{display:"flex",flexDirection:"column",gap:10}}>{d.recs.map(function(r,i){return <div key={i} style={{background:T.faint,border:"1px solid "+T.border,borderRadius:10,padding:14}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <div style={{display:"flex",gap:6}}><Bd t={r.recommendation_type||"general"} c={T.blue}/><Bd t={r.priority||"medium"} c={sc(r.priority||"medium")}/></div>
          <Bd t={r.status} c={sc(r.status)}/>
        </div>
        <div style={{fontSize:12,fontWeight:600,marginBottom:4}}>{r.recommendation}</div>
        {r.reasoning&&<div style={{fontSize:11,color:T.muted,marginBottom:8}}>{r.reasoning}</div>}
        {r.status==="pending"&&<div style={{display:"flex",gap:8}}>
          <Btn onClick={function(){handleRec(r.id,"accepted");}} bg={T.green} sm>Accept</Btn>
          <Btn onClick={function(){handleRec(r.id,"dismissed");}} bg={T.muted} sm>Dismiss</Btn>
        </div>}
      </div>;})}</div>}
    </Crd>
  </div>;
}
export { SC as PageAgentOps };
